import { model } from './model';
export type { Sfyr, SfyrResolver } from './sfyr';
export type { SfyrAnyModel, SfyrAnySchema, SfyrValue } from './types';

export const stringifyr = {
  model,
};
